module.exports = __webpack_public_path__ + "media/customizations/elevon/logo-new-51ac82cbbcfc4fbe104c91008d3ef9a1.png";